/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { CSSProperties, FC, useState } from "react";

export interface ImageLoaderProps {
  url?: string;
  fetched?: boolean;
  width?: number | string; // wrapper width and height.
  height?: number | string;
  cached?: boolean; // when the local image already cached.
  type?: "cover" | "contain";
  className?: string;
  lazyImageFulLWidth?: boolean;
  alt?: string;
  style?: CSSProperties;
  cacheImage?: () => void; // cached image loaded in session.
}

export const ImageLoader: FC<ImageLoaderProps> = ({
  url,
  cacheImage,
  width = "100%",
  height = "100%",
  cached,
  type = "cover",
  className = "",
  alt = "Lazy Loaded Image",
  lazyImageFulLWidth = false,
  style,
}) => {
  const [loaded, setLoaded] = useState(cached);
  return (
    <div
      className={`image-loading-wrapper ${className}`}
      style={{ width, height }}
    >
      {!loaded && <div className="skeleton"></div>}
      <img
        style={style}
        className={`lazy-image ${loaded ? "loaded" : ""} ${type} ${
          lazyImageFulLWidth ? "w-100" : ""
        }`}
        src={url}
        alt={alt}
        loading="lazy"
        onLoad={() => {
          setLoaded(true);
          if (cacheImage) cacheImage();
        }}
      />
    </div>
  );
};
